import { ApiBase } from '../ApiBase';
class CreatorSupportChannelsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getCreatorSupportChannels = (params) => {
            return this.get('/v3/creator-support/contacts', params);
        };
    }
}
export const CreatorSupportChannelsApiClient = new CreatorSupportChannelsApiClientModel();
